export enum EmployeePosition {
  Processor = 'Processor',
  Consultant = 'Consultant',
}
